export default __webpack_public_path__ + "static/media/traffic-time-signs.f25a0c6c.svg";